export interface dayToDay {
  value: string;
  city: string;
}
export interface Tours {
  eventType: "tour",
  // _id: string;
  id: number;
  tourName: string;
  tourName_de: string;
  tourName_es: string;
  contactEmail: string;
  tourOwnerPicture: CloudinaryImg[];
  tourOwnerName: string;
  ownerDescription: string;
  tourPictures: CloudinaryImg[];
  tourDescription: string;
  program: string;
  qualifications: string;
  localSupervisorName: string;
  localSupervisorPhone: string;
  location: string;
  // startDate: Date | string;
  // endDate: Date | string;
  startDate: string;
  endDate: string;
  capacity: number;
  category: string;
  price: number;
  rating?: number;
  pricePerDay: number;
  pricePerMonth: number;
  additionalPrice: string;
  additionalPrice_de: string;
  additionalPrice_es: string;
  accommodationDescription: string;
  accommodationPicture: CloudinaryImg[];
  foodDescription: string;
  transportation: string;
  transportationPicture: CloudinaryImg[];
  additionalInfo: string;
  dayToDay: dayToDay[];
  dayToDay_es: dayToDay[];
  dayToDay_de: dayToDay[];
  status: string;
  dayOne: string;
  possibleAdditionalCost: number;
  standardAccomodation: string;
  extraAccommodation: ExtraAccommodation[];
  extraAccommodation_de: ExtraAccommodation[];
  extraAccommodation_es: ExtraAccommodation[];
  numberOfReservations: number;
  noticePeriod: number;
  minParticipants: number;
  duration: number;
  createdBy: string;
  customId: string;
  minCapacity?: number;
  feedback: any[];
  available: Boolean;
  bookings?: number;
  confirm?: true,
  includedEventsDates: IncludedDateRangeObject[];
  consumerPrice?: number;
  consumerPricePerDay: number;
  levelOfDifficulty: string;
  nearAirport: string;
  eventCity: string;
  natureOfEvent: string;
  spokenLanguages: string;
  natureOfEventdescription: string;
  choiceOfFood: string;
  extraChoiceOfFood: ExtraChoiceOfFood[];
  extraChoiceOfFood_de: ExtraChoiceOfFood[];
  extraChoiceOfFood_es: ExtraChoiceOfFood[];
  foodPrice: number;
  vouchers: Voucher[];
  companyInfo_de: string;
  ownerDescription_de: string;
  tourDescription_de: string;
  accommodationDescription_de: string;
  foodDescription_de: string;
  transportation_de: string;
  additionalInfo_de: string;
  typicalDay_de: string;
  natureOfEventdescription_de: string;
  spokenLanguages_de: string;
  companyInfo_es: string;
  ownerDescription_es: string;
  tourDescription_es: string;
  accommodationDescription_es: string;
  foodDescription_es: string;
  transportation_es: string;
  additionalInfo_es: string;
  natureOfEventdescription_es: string;
  spokenLanguages_es: string;
  airportCost: number;
  sdg: string;
  sdg_de: string;
  sdg_es: string;
  natureOfEventHeading?:string;
  event_day_details: EventDetailsFile;
  recurrenceSelection: RecurrenceSelection | any;
  lang: string;
}
export interface Voucher {
  createdAt: Date;
  discountValue: number;
  id: number;
  updatedAt: Date;
  voucher: string;
  isPercentageDiscount: boolean;
}
export interface ExtraAccommodation {
  category: string;
  extraPrice: string;
  description: string;
}
export interface ExtraChoiceOfFood {
  category: string;
  description: string;
}

export interface CloudinaryImg {
  imageURL: string;
  public_id: string;
  imageName: string;
}

export interface EventDetailsFile {
  url: string;
}

export const SET_ALL_TOURS = "SET_ALL_TOURS";
export const SET_UPCOMING_TOURS = "SET_UPCOMING_TOURS";
export const SET_CALENDAR_DATA = "SET_CALENDAR_DATA";

export interface tourState {
  upcomingTours: Tours[];
  allTours: Tours[];
  calendarData: any
}

export interface SetAllToursAction {
  type: typeof SET_ALL_TOURS;
  payload: Tours[];
}

export interface SetUpcomingToursAction {
  type: typeof SET_UPCOMING_TOURS;
  payload: Tours[];
}

export interface IncludedDateRangeObject {
  start: string | Date,
  end: string | Date
  capacity: number
  confirm: boolean
}

export interface RecurrenceSelection {
  isRepeat: boolean,
  dropdownSelection: "DAILY" | "WEEKLY" | "MONTHLY",
  radioSelection: "Never" | "Occurence" | "After", 
  daySelection: any,
  occurencesCount: string | number,
  after: string | Date,
  dateRange: any
}

export type ToursActionTypes = SetAllToursAction | SetUpcomingToursAction;
